/** @enum {string} */
export const Properties = Object.freeze({
  ABBREVIATION: 'abbreviation',
  ACRONYM: 'acronym',
  ACT_TYPE: 'actType',
  ACTS_MANDATORY: 'actsMandatory',
  ADDRESS: 'address',
  BIRTHDAY: 'birthday',
  CITY: 'city',
  COLOR: 'color',
  COMMENT: 'comment',
  CONSTRAINT_TYPE: 'constraintType',
  COUNTRY: 'country',
  CREATED_AT: 'createdAt',
  DESCRIPTION: 'description',
  EMAIL: 'email',
  ENABLE: 'enable',
  END_DATE: 'endDate',
  ENTITY_NAME: 'entityName',
  ID: 'id',
  FILES: 'files',
  FIRST_NAME: 'firstName',
  GENDER: 'gender',
  GLOBAL_MESSAGE: 'gloablMessage',
  HOSPITAL_DEPARTMENTS: 'hospitalDepartments',
  INSTITUTION: 'institution',
  INSTITUTIONS: 'institutions',
  INSTITUTION_ACRONYM: 'institutionAcronym',
  INSTITUTION_ADDRESS: 'institutionAddress',
  INSTITUTION_CITY: 'institutionCity',
  INSTITUTION_COUNTRY: 'institutionCountry',
  INSTITUTION_EMAIL: 'institutionEmail',
  INSTITUTION_GROUP: 'institutionGroup',
  INSTITUTION_NAME: 'institutionName',
  INSTITUTION_ZIPCODE: 'institutionZipcode',
  INTERNSHIP: 'internship',
  DURATION: 'duration',
  LANGUAGE_LOCALE: 'languageLocale',
  LAST_NAME: 'lastName',
  MANAGED: 'managed',
  METADATA: 'metadata',
  NAME: 'name',
  NISS: 'niss',
  PHONE: 'phone',
  PHONE_NUMBER: 'phoneNumber',
  PREMIUM: 'premium',
  PROPERTY_NAME: 'propertyName',
  REQUEST_ORIGIN: 'requestOrigin',
  REQUEST_PERIODS: 'requestPeriods',
  SCHOOL: 'school',
  SECTION: 'section',
  SECTIONS: 'sections',
  SECTION_GROUP: 'sectionGroup',
  SECTION_TO_YEAR: 'sectionToYear',
  SECTOR: 'sector',
  SECTORS: 'sectors',
  SECTOR_NAME: 'sectorName',
  START_DATE: 'startDate',
  STUDENT: 'student',
  TOTAL: 'total',
  TYPE: 'type',
  VERIFIED: 'verified',
  ZIPCODE: 'zipcode'
})
